import type { RuntimeEnvironmentKey, RuntimeFlagsState } from "./runtimeFlags";
import { RuntimeStateCard } from "./RuntimeStateCard";

interface RuntimeEnvironmentStateNoticeProps {
  environment: RuntimeEnvironmentKey;
  state: RuntimeFlagsState | null;
  isLoading: boolean;
}

export function RuntimeEnvironmentStateNotice({
  environment,
  state,
  isLoading,
}: RuntimeEnvironmentStateNoticeProps) {
  const label = environmentLabel(environment);
  if (isLoading) {
    return (
      <RuntimeStateCard
        title={`Reading ${label}`}
        body="Loading live configuration…"
      />
    );
  }
  if (state?.status === "unconfigured") {
    return (
      <RuntimeStateCard
        title={`${label} is not configured`}
        body="The selected dashboard API or its CONFIG_INVENTORY_JSON is not available. Apply the environment-local dashboard infrastructure before comparing it."
      />
    );
  }
  if (state?.status === "unauthorized") {
    return (
      <RuntimeStateCard
        title={`${label} is not authorized`}
        body="Your CRM session was rejected before an AWS dashboard credential was used. Sign in again or verify your sales membership."
      />
    );
  }
  if (state?.status === "error") {
    return (
      <RuntimeStateCard
        title={`${label} failed to load`}
        body={state.message}
      />
    );
  }
  return null;
}

function environmentLabel(environment: RuntimeEnvironmentKey) {
  return environment === "stg"
    ? "customer-facing production (`stg`)"
    : "engineering staging (`staging`)";
}
